import React, { useEffect, useState } from "react";
// import axios from "axios";
import HookForm from "../../components/HookForm/HookForm";
import TextField from "../../components/TextField/TextField";
import CustomButton from "../../components/CustomButton/CustomButton";
import Message from "../../util/message";
import Constant from "../../util/constant";
import LoginImg from "../../assests/img/loginimg.svg";
import Logo from "../../assests/img/logo.svg";
import CheckBox from "../../components/CheckBox/CheckBox";
import Label from "../../components/Label/Label";
import "./Login.scss";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { getLoginPageAction } from "../../reduxThings/slices/DigipankSlices";
import { login } from "../../services/authApi";
import {
  buildUserFromAuthResponse,
  getRememberedEmail,
  isAdminUser,
  setAuthSession,
} from "../../util/auth";
import Seo from "../../components/Seo/Seo";

const loginForm = {
  email: {
    name: "email",
    validate: {
      required: {
        value: true,
        message: Message.ERRORMESSAGE.EMAILEMPTY,
      },
      pattern: {
        value: Constant.REGEX.email,
        message: Message.ERRORMESSAGE.EMAILINVALID,
      },
    },
  },
  password: {
    name: "password",
    validate: {
      required: {
        value: true,
        message: Message.ERRORMESSAGE.PASSWORDEMPTY,
      },
    },
  },
};

function Login() {
  let navigate = useNavigate();
  const dispatch=useDispatch();
  const clickToNavigateDetailsPage = () => {
    navigate("/detailspage");
  };
  const clickToNavigateLeavePage = () => {
    navigate("/leave");
  };
  const [form, setLoginForm] = React.useState();
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const rememberedEmail = getRememberedEmail();
  const [rememberMe, setRememberMe] = useState(Boolean(rememberedEmail));
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [carousalStatus, setCarousalStatus] = useState(true);

  const handleClick = (data) => {
    setCarousalStatus(data);
  };

  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener("resize", handleResize);

    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const onFormSubmit = async (data) => {
    setIsSubmitting(true);

    try {
      const response = await login({
        email: data.email,
        password: data.password,
      });
      const token = response?.accessToken || response?.token;

      if (!token) {
        window.alert("Login failed: no access token received.");
        return;
      }

      const user = buildUserFromAuthResponse(response, data.email);
      setAuthSession({ token, user }, rememberMe);
      navigate(isAdminUser() ? "/detailspage" : "/leave");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Login failed. Please check your credentials.";
      window.alert(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    dispatch(getLoginPageAction());
  }, [dispatch]);

  const appData = useSelector(
    (e) => e?.DigipankSlice?.LoginPageState?.LoginPageStateData,
  );
  return (
    <div className="login_Container">
      <Seo title="Login" path="/login" noindex />
      <Header handleClick={handleClick} />
      <div
        className="login_Page"
        style={{ height: dimensions.height - 120 + "px" }}
      >
        <div className="center_Section">
          <div className="left_Side">
            <div className="img_Section">
              <img
                src={LoginImg}
                alt="Employee login illustration"
                fluid="true"
                className="main_Img"
              />
              <img src={Logo} alt="Digipank logo" fluid="true" className="main_Img" />
            </div>
          </div>
          <div className="right_Side">
            <div className="input_Center">
              <Label title={appData.loginBtn} className="titleText"></Label>
              <HookForm
                defaultForm={{ email: rememberedEmail, password: "" }}
                init={(form) => setLoginForm(form)}
                onSubmit={onFormSubmit}
              >
                {(formMethod) => {
                  return (
                    <div className="form1">
                      <TextField
                        formMethod={formMethod}
                        rules={loginForm.email.validate}
                        name={loginForm.email.name}
                        errors={formMethod?.errors}
                        autoFocus={true}
                        type="text"
                        placeholder={appData.emailPlaceholder}
                      />
                      <TextField
                        formMethod={formMethod}
                        rules={loginForm.password.validate}
                        name={loginForm.password.name}
                        errors={formMethod?.errors}
                        type="password"
                        placeholder={appData.password}
                        iconClass="Password"
                        textFieldCss="textFieldCss"
                      />
                      <div className="remember_Forgot">
                        <CheckBox
                          labelTitle={appData.checkbox}
                          id="rememberMe"
                          checked={rememberMe}
                          onCheckedChange={(event, checked) =>
                            setRememberMe(checked)
                          }
                        />
                        <button type="button" className="forgot_Pass">
                          {appData.forgotPassword}
                        </button>
                      </div>
                      <div className="login_Btn">
                        <CustomButton
                          title={isSubmitting ? "Logging in..." : appData.loginBtn}
                          type="submit"
                          className={`submitBtn${isSubmitting ? " disabled" : ""}`}
                        />
                      </div>
                    </div>
                  );
                }}
              </HookForm>
              {/* <CustomButton
                title="Leave Page"
                onClick={clickToNavigateLeavePage}
              ></CustomButton> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
